var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { VBox, HBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { Button, Intent } from "framework/controls/button";
import { useCompetitionRegistration, RegistrationPhase } from "../store";
import { CompetitionView } from "./competition/view";
import { cls_colorMagenta60, cls_colorOrange50, cls_gap_form, cls_p4b, cls_p5r } from "style/index.css";
import { cls_align_items_center, cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
import { ClassesDialog } from "./classes_dialog";
import { Checkbox } from "framework/controls/checkbox";
import { useEventCalendarCompetitions } from "../../competitions/store";
import { getCompetitionNaming } from "public_app/view/entity";
import { toSingleString } from "framework/validation/strings";
import { GroupOrFormationMembersDialog } from "./viewGroupMembersDialog";
var Content = function () {
    var collection = useEventCalendarCompetitions()[0].collection;
    var _a = useCompetitionRegistration(), state = _a[0], actions = _a[1];
    var hasItems = state.competitions.competitions.length > 0;
    var checkboxGetter = function (field) {
        return state.showOtherCompetitions;
    };
    var competitionsWithError = collection.filter(function (c) { return c.id.toString() in state.competitions.errors; });
    return React.createElement(VBox, { className: [cls_gap_form, cls_align_items_stretch] },
        hasItems
            ? React.createElement(VBox, null, state.competitionStates.map(function (cs) { return React.createElement(CompetitionView, { key: cs.entity.competitionId, competitionState: cs }); }))
            : React.createElement(VBox, { className: cls_p5r }, 'V této soutěžní akci nemůžete startovat v žádné soutěži.'),
        competitionsWithError.length > 0 && React.createElement(VBox, { className: cls_gap_form },
            React.createElement(Checkbox, { name: "showOtherCompetitions", label: hasItems ? "Ukázat ostatní soutěže" : "Ukázat soutěže s vysvětlením", state: state, getter: checkboxGetter, setter: function () { return actions.setShowOtherCompetitions(!state.showOtherCompetitions); } }),
            state.showOtherCompetitions && React.createElement(React.Fragment, null, competitionsWithError.map(function (c) { return React.createElement(VBox, { key: c.id },
                React.createElement(HBox, { className: [] }, getCompetitionNaming(c)),
                React.createElement(HBox, { className: [cls_colorMagenta60] }, toSingleString(state.competitions.errors[c.id.toString()].errors))); }))),
        React.createElement(ClassesDialog, null),
        React.createElement(HBox, { className: cls_gap_form }, React.createElement(Button, { onClick: actions.registerOtherAttendee, intent: Intent.NotAction }, 'Přihlásit jiného soutěžícího')));
};
var View = function () {
    var _a;
    var _b = useCompetitionRegistration(), _c = _b[0], eventId = _c.eventId, eventCompetitionId = _c.eventCompetitionId, competitions = _c.competitions, selectedAttendee = _c.selectedAttendee, registrationPhase = _c.registrationPhase, registrationName = _c.registrationName, loadAvailableCompetitions = _b[1].loadAvailableCompetitions;
    var loading = competitions.loading, loadFailure = competitions.loadFailure, errors = competitions.errors, messageUnauthorized = competitions.messageUnauthorized;
    React.useEffect(function () {
        var canLoad = registrationPhase == RegistrationPhase.AvailableCompetitions
            && selectedAttendee != null
            && eventCompetitionId == eventCompetitionId
            && !competitions.initialized;
        if (canLoad) {
            var compInfo = __assign({}, selectedAttendee);
            delete compInfo.name;
            loadAvailableCompetitions();
        }
    }, [registrationPhase, selectedAttendee, eventId, eventCompetitionId]);
    var showView = registrationPhase == RegistrationPhase.AvailableCompetitions;
    var showContent = selectedAttendee != null && !loading && !loadFailure;
    return showView && React.createElement(VBox, { className: cls_gap_form },
        React.createElement(GroupOrFormationMembersDialog, null),
        React.createElement(HBox, { className: [cls_align_items_center, cls_gap_form] },
            React.createElement(HBox, null, "Přihlášení pro:"),
            React.createElement(HBox, { className: cls_p4b }, "".concat(registrationName))),
        loading && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(React.Fragment, null, messageUnauthorized ? React.createElement(VBox, { className: cls_gap_form },
            React.createElement(VBox, { className: cls_colorOrange50 }, "Omlouváme se, uvedeného soutěžícího nemůžeme do soutěží přihlásit, k přihlášení tohoto soutěžícího nejste oprávněn/a."),
            React.createElement(VBox, null, "Pokud přihlašujete soutěžícího jako jeho rodič, požádejte o propojení sekretariát. Pokud přihlašujete soutěžícího jako zástupce klubu, přihlašte soutěžícího do svazu pod svým klubem.")) :
            ((_a = errors['']) === null || _a === void 0 ? void 0 : _a.errors) ? React.createElement(VBox, { className: cls_colorMagenta60 }, errors[''].errors) :
                React.createElement(LoadingError, null)),
        showContent && React.createElement(Content, null));
};
export { View as CompetitionsView, };
